import SpecificTriggerRules from 'modules/automation-rules/specific-trigger-rules'
import { getDefaultTriggerValue } from 'modules/automation-rules/triggers/utils/get-default-trigger-value'
import { useStoreOptinRules } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-optin-rules'
import { useStoreOptinTriggers } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-optin-triggers'
import { useStoreRuleData } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-rule-data'
import { fillTriggerWithStoreData } from 'modules/stores/store/content/optin/optin-rules/utils/fill-trigger-with-store-data'
import { splitRelatedAndUnrelatedTriggers } from 'modules/stores/store/content/optin/optin-rules/utils/split-related-and-unrelated-triggers'
import { StoreId } from 'modules/stores/types/stores-interface'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface OptinRulesProps {
  storeId: StoreId
  optinId: number
}

function OptinRules({ storeId, optinId }: OptinRulesProps) {
  const { t } = useLocoTranslation()
  const specificTriggerRulesData = useStoreOptinRules(optinId)

  const availableTriggersData = useStoreOptinTriggers(optinId)

  const { storeTriggerData } = useStoreRuleData(storeId, optinId)

  return (
    <SpecificTriggerRules
      noRelatedMessage={id => (
        <TransLoco
          t={t}
          components={{
            a: <LinkWithoutPrefetch href={`/automation-rules/${id}`} className={'primary-link'} />,
          }}
          i18nKey={'dashboard.automation_rule.trigger.has_non_related_store_optin'}
        />
      )}
      availableTriggersData={availableTriggersData}
      specificTriggerRulesData={specificTriggerRulesData}
      getRelatedAndUnrelatedTriggersData={triggers =>
        splitRelatedAndUnrelatedTriggers(triggers, storeTriggerData?.itemId)
      }
      customAddTriggerHandler={
        storeTriggerData &&
        ((trigger, maxTriggerId) =>
          fillTriggerWithStoreData(getDefaultTriggerValue(trigger, maxTriggerId), storeTriggerData))
      }
    />
  )
}

export default OptinRules
